import { v4 as uuidv4 } from 'uuid'
import { fetchCharacters } from '@client/components'
import { Utils as utils } from '@client/utility'

interface CharacterExtended {
  title?: string
  name?: string
  description?: string
  persona?: string
  model_instructions?: string
  first_message?: string[]
  message_example?: string
  scenario?: string
  gender?: string
  tags?: string[]
  lorebook?: string
  attribute?: string
  creator_notes?: string
  gallery?: string[]
  profile_image?: string
  creator_uuid?: string
}

interface CreateChatResponse {
  chat_uuid: string
  error?: string
}

export async function CreateNewChat(
  characterUuid: string,
  userUuid: string
): Promise<CreateChatResponse> {
  try {
    if (!characterUuid?.trim()) throw new Error('Invalid character UUID')
    if (!userUuid?.trim()) throw new Error('Invalid user UUID')

    const chatUuid = uuidv4()

    const { characters } = await fetchCharacters({
      filterCharUUID: characterUuid,
      filterCreatorUUID: userUuid,
      itemsPerPage: 1,
      currentPage: 1
    })

    const character = characters?.[0] as CharacterExtended
    if (!character) throw new Error('Character not found')

    const insertResult = await utils.db.insert({
      tables: 'chats',
      data: {
        chat_uuid: chatUuid,
        char_uuid: characterUuid,
        user_uuid: userUuid,
        description: character.description || '',
        first_message: character.first_message || [],
        model_instructions: character.model_instructions || '',
        name: character.name || '',
        lorebook: character.lorebook || '',
        persona: character.persona || '',
        scenario: character.scenario || '',
        is_temporary: true,
        expires_at: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
        attribute: character.attribute || '',
        title: character.title || '',
        message_example: character.message_example || '',
        gender: character.gender || 'neutral',
        profile_image: character.profile_image || ''
      }
    })

    if (!insertResult?.length) throw new Error('Failed to create chat in database')

    return { chat_uuid: chatUuid }
  } catch (error: any) {
    return {
      chat_uuid: '',
      error: error.message || 'An unexpected error occurred'
    }
  }
}
